document.addEventListener('DOMContentLoaded', () => {
  // Sticky & Dynamic Header Scroll Handling
  const stickyHeader = document.querySelector('[data-sticky-header]');
  if (stickyHeader) {
    let lastScrollY = window.scrollY;
    let ticking = false;

    // Dynamically calculate header height for overlay offset & spacer
    const updateHeaderHeight = () => {
      const headerElem = stickyHeader.querySelector('.header') || stickyHeader;
      if (headerElem) {
        const height = headerElem.offsetHeight;
        document.documentElement.style.setProperty('--header-height', `${height}px`);
        stickyHeader.style.setProperty('--header-height', `${height}px`);
      }
    };
    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight, { passive: true });

    const isDrawerOpen = () => {
      const drawer = document.querySelector('[data-mobile-drawer]');
      const searchPopup = document.querySelector('[data-search-popup]');
      return (
        (drawer && drawer.classList.contains('header__mobile-drawer--open')) ||
        (searchPopup && searchPopup.classList.contains('is-open'))
      );
    };

    const updateHeaderState = () => {
      const currentScrollY = window.scrollY;
      const announcementBar = document.querySelector('[data-announcement-bar]');
      const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
      const topThreshold = announcementBarHeight;

      // Don't hide header if any drawer is open
      if (isDrawerOpen()) {
        stickyHeader.classList.remove('header-sticky--hidden');
        lastScrollY = currentScrollY;
        ticking = false;
        return;
      }

      if (currentScrollY <= topThreshold) {
        // At the very top boundary (at or below announcement bar)
        const remainingAnnouncement = Math.max(0, announcementBarHeight - currentScrollY);
        stickyHeader.style.top = `${remainingAnnouncement}px`;
        stickyHeader.classList.add('header-sticky--at-top');
        stickyHeader.classList.remove('header-sticky--scrolled', 'header-sticky--hidden');
      } else {
        // Scrolled past top boundary
        stickyHeader.style.top = '0px';
        stickyHeader.classList.remove('header-sticky--at-top');

        const scrollDiff = currentScrollY - lastScrollY;

        if (scrollDiff > 0 && currentScrollY > topThreshold + 30) {
          // Scrolling DOWN: Hide header
          stickyHeader.classList.add('header-sticky--hidden');
        } else if (scrollDiff < 0) {
          // Scrolling UP (even by 1px): Show header with white background
          stickyHeader.classList.remove('header-sticky--hidden');
          stickyHeader.classList.add('header-sticky--scrolled');
        }
      }

      lastScrollY = Math.max(0, currentScrollY);
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          window.requestAnimationFrame(updateHeaderState);
          ticking = true;
        }
      },
      { passive: true }
    );

    // Initial check on load
    updateHeaderState();
  }

  // Search Drawer Handling
  const searchTrigger = document.querySelector('[data-search-trigger]');
  const searchClose = document.querySelector('[data-search-close]');
  const searchDrawer = document.querySelector('[data-search-drawer]');
  const searchInput = document.querySelector('[data-search-input]');

  if (searchTrigger && searchDrawer) {
    searchTrigger.addEventListener('click', () => {
      searchDrawer.classList.add('header__search-drawer--open');
      setTimeout(() => searchInput && searchInput.focus(), 150);
    });
  }

  if (searchClose && searchDrawer) {
    searchClose.addEventListener('click', () => {
      searchDrawer.classList.remove('header__search-drawer--open');
    });
  }

  // Mobile Navigation Drawer Handling
  const menuTrigger = document.querySelector('[data-mobile-menu-trigger]');
  const drawerClose = document.querySelector('[data-mobile-drawer-close]');
  const drawer = document.querySelector('[data-mobile-drawer]');
  const overlay = document.querySelector('[data-mobile-drawer-overlay]');

  if (menuTrigger && drawer && overlay) {
    menuTrigger.addEventListener('click', () => {
      drawer.classList.add('header__mobile-drawer--open');
      overlay.classList.add('header__mobile-drawer-overlay--open');
    });
  }

  const closeMobileMenu = () => {
    if (drawer) drawer.classList.remove('header__mobile-drawer--open');
    if (overlay) overlay.classList.remove('header__mobile-drawer-overlay--open');
  };

  if (drawerClose) drawerClose.addEventListener('click', closeMobileMenu);
  if (overlay) overlay.addEventListener('click', closeMobileMenu);

  // Mobile sidebar search → open search popup
  const mobileSearchToPopup = document.querySelector('[data-mobile-search-to-popup]');
  if (mobileSearchToPopup) {
    mobileSearchToPopup.addEventListener('click', () => {
      closeMobileMenu();
      setTimeout(() => {
        const searchPopupTrigger = document.querySelector('[data-search-trigger]');
        if (searchPopupTrigger) {
          searchPopupTrigger.click();
        }
      }, 150);
    });
  }

  // Mobile sidebar localization dropdown toggle
  const mobileLocaleToggle = document.querySelector('[data-mobile-locale-toggle]');
  const mobileLocaleMenu = document.querySelector('[data-mobile-locale-menu]');
  if (mobileLocaleToggle && mobileLocaleMenu) {
    mobileLocaleToggle.addEventListener('click', () => {
      const isOpen = mobileLocaleMenu.style.display !== 'none';
      mobileLocaleMenu.style.display = isOpen ? 'none' : 'block';
      mobileLocaleToggle.setAttribute('aria-expanded', !isOpen);
    });
  }

  // Live Cart Count Updater
  window.updateHeaderCartCount = async function(count) {
    let newCount = count;
    if (typeof newCount === 'undefined') {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        newCount = cart.item_count;
      } catch (err) {
        console.error('Failed to fetch cart count', err);
        return;
      }
    }
    const cartCountEls = document.querySelectorAll('[data-cart-count]');
    cartCountEls.forEach((el) => {
      el.textContent = newCount;
    });
  };

  // Sinkronkan teks currency di header jika ada URL parameter ?currency=
  const syncHeaderCurrencyFromUrl = () => {
    let activeCurrency = '';
    const urlParams = new URLSearchParams(window.location.search);
    const paramCurrency = urlParams.get('currency');
    if (paramCurrency) {
      activeCurrency = paramCurrency.toUpperCase();
    } else {
      // Baca dari localStorage Bucks jika tidak ada di URL
      try {
        const auto = localStorage.getItem('buckscc_auto_currency');
        if (auto) {
          const parsed = JSON.parse(auto);
          if (parsed && parsed.currency) activeCurrency = parsed.currency.toUpperCase();
        }
        if (!activeCurrency) {
          activeCurrency = (localStorage.getItem('buckscc_customer_currency') || localStorage.getItem('buckscc_currency') || '').toUpperCase();
        }
      } catch (e) {}
    }

    if (!activeCurrency) return;

    const upperCurrency = activeCurrency;
    const validCurrencies = ['USD', 'IDR', 'SGD', 'MYR'];
    if (validCurrencies.includes(upperCurrency)) {
      const isIndonesian = window.location.pathname.startsWith('/id');

      // 1. Update text trigger toggle di desktop jika bahasa Inggris
      const headerCountryCurrencyText = document.querySelector('.header__country-currency-text');
      if (headerCountryCurrencyText && !isIndonesian) {
        const spans = headerCountryCurrencyText.querySelectorAll('span');
        if (spans.length >= 3) {
          spans[2].textContent = upperCurrency;
        }
      }

      // 2. Update opsi label di dropdown desktop (hanya untuk English)
      document.querySelectorAll('.header__localization-option-label').forEach((label) => {
        if (label.textContent.includes('English') && label.textContent.includes('·')) {
          label.textContent = `English · ${upperCurrency}`;
        }
      });

      // 3. Update opsi tombol di mobile drawer (hanya untuk English)
      document.querySelectorAll('.header__mobile-lang-btn[data-lang-code="en"] span').forEach((btnSpan) => {
        btnSpan.textContent = `English · ${upperCurrency}`;
      });
    }
  };
  syncHeaderCurrencyFromUrl();

  // Localization Dropdown Handling
  const localizationDropdown = document.querySelector('[data-localization-dropdown]');
  const localizationBtn = document.querySelector('[data-localization-btn]');
  
  if (localizationDropdown && localizationBtn) {
    localizationBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = localizationDropdown.classList.toggle('is-open');
      localizationBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    document.addEventListener('click', (e) => {
      if (!localizationDropdown.contains(e.target)) {
        localizationDropdown.classList.remove('is-open');
        localizationBtn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // Handle Language Option Clicks
  const handleLangSelect = (btn) => {
    const langCode = btn.getAttribute('data-lang-code');
    const form = btn.closest('form');
    if (form) {
      const input = form.querySelector('input[name="language_code"]');
      if (input) input.value = langCode;
      form.submit();
    } else {
      const currentUrl = new URL(window.location.href);
      if (langCode === 'id') {
        if (!currentUrl.pathname.startsWith('/id')) {
          currentUrl.pathname = '/id' + currentUrl.pathname;
        }
      } else {
        if (currentUrl.pathname.startsWith('/id')) {
          currentUrl.pathname = currentUrl.pathname.replace(/^\/id/, '') || '/';
        }
      }
      window.location.href = currentUrl.toString();
    }
  };

  document.querySelectorAll('.header__localization-option, .header__mobile-lang-btn').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      if (btn.type === 'button') {
        e.preventDefault();
        handleLangSelect(btn);
      }
    });
  });

  // Listen for Shopify standard cart update events
  document.addEventListener('cart:updated', (e) => {
    const count = e.detail && typeof e.detail.item_count !== 'undefined' ? e.detail.item_count : undefined;
    window.updateHeaderCartCount(count);
  });
  document.addEventListener('cart:refresh', () => {
    window.updateHeaderCartCount();
  });
});
